export enum InfoCardType {
  Success = 'success',
  Warning = 'warning',
  Error = 'error'
}
